<template lang="pug">
	.asset-image-info(v-if="showed && image" v-window)
		.card
			.card-header
				i.fa.fa-magic
				span Image Info
			.card-body.collapse.show
				.form-line.separator
					.canvas(:style="{width: canvasWidth + 'px', height: canvasHeight + 'px'}" @wheel="setCurrImageScaleByWheel($event)" @mousedown="startDrag($event)")
						.image(ref="currEl" :style="{backgroundImage: `url(${image.path})`, width: currImageWidth * globalScale + 'px', height: currImageHeight * globalScale + 'px', left: (canvasWidth / 2 - currImageWidth * globalScale / 2 + currImageOffset[0] * globalScale) + 'px', top: (canvasHeight / 2 - currImageHeight * globalScale / 2 + currImageOffset[1] * globalScale) + 'px', transform: `rotate(${currImageRotation}deg)`}")
						.original-image-rect(v-if="editMode" :style="{backgroundImage: `url(${this.origImageObj.src})`, width: origImageWidth * globalScale + 'px', height: origImageHeight * globalScale + 'px', left: (canvasWidth / 2 - origImageWidth * globalScale / 2) + 'px', top: (canvasHeight / 2 - origImageHeight * globalScale / 2) + 'px'}")
				.form-line.controls.separator(v-if="editMode")
					.control
						span Scale:
						InputCoordsDrag(v-on:change="setCurrImageScale($event)" v-on:input="setCurrImageScale($event)" :default="[0, 0]" :value="currImageScale" :options="{changes: {min: currImageMinScale, max: currImageMaxScale, step: currImageScaleStep, accuracy: 2}, controlOptions: {drag: true, sameValueByDefault: true, revertY: true}}" theme="dark-medium")
						//InputRange(v-on:change="setCurrImageScale($event)" v-on:input="setCurrImageScale($event)" :default="1" :value="currImageScale" :options="{changes: {min: currImageMinScale, max: currImageMaxScale, step: currImageScaleStep}, controlOptions: {min: currImageMinScale, max: currImageMaxScale, step: currImageScaleStep}}" theme="dark-medium")
					.control
						span Offset:
						InputCoordsDrag(v-on:change="setCurrImageOffset($event)" v-on:input="setCurrImageOffset($event)" :default="[0, 0]" :value="currImageOffset" :options="{changes: {min: -1000, max: 1000, step: 1, accuracy: 0}, controlOptions: {drag: true}}" theme="dark-medium")
					.control
						span Rotation:
						InputAngle(v-on:change="setCurrImageRotation($event)" v-on:input="setCurrImageRotation($event)" :default="0" :value="currImageRotation" :options="{changes: {min: -360, max: 360, step: 1, accuracy: 0}}" theme="dark-medium")
				.form-actions
					button.btn.btn-primary(v-if="editMode" type="button" @click="save()")
						i.fa.fa-save
						span Save changes
					button.btn.btn-outline-secondary(v-if="editMode" type="button" @click="editMode = false")
						i.fa.fa-close
						span Cancel edit
					button.btn.btn-primary(v-if="!editMode" type="button" @click="editMode = true")
						i.fa.fa-pencil
						span Edit dimensions
					button.btn.btn-outline-danger(v-if="!editMode && assetDimension" type="button" @click="reset()")
						i.fa.fa-remove
						span Reset dimensions changes
					button.btn.btn-outline-primary.download-button(v-if="!editMode" type="button" @click="downloadImage(variation, image)" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Download image'}")
						i.fa.fa-download
					button.btn.btn-dark.right-button(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'
	import { Auth } 			from './../../services/Auth'

	import InputRange			from './../Editor/Controls/InputRange'
	import InputCoordsDrag		from './../Editor/Controls/InputCoordsDrag'
	import InputAngle			from './../Editor/Controls/InputAngle'

	export default {
		name: "AssetImageInfo",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Creative Dimension Added",
				"Selected Creative Dimension Changed",
				"Selected Creative Dimension Removed"
			],
			events: {
				"Show AssetImageInfo": function(creative, asset, variation, image) {

					this.editMode = false;

					this.creative = creative;
					this.asset = asset;
					this.variation = variation;
					this.image = image;

					this.currImageObj.src = image.path;
					this.origImageObj.src = Asset.getAssetOriginalUrl(this.asset);

					this.currImageOffsetChanged = false;
					this.currImageScaleChanged = false;
					this.currImageRotationChanged = false;

					this.currImageOffset = [0, 0];
					this.currImageScale = [1, 1];
					this.currImageRotation = 0;

					this.update();

					console.log('asset', this.asset);

				},
				"Selected Creative Dimension Removed": function() {

					this.currImageOffset = [0, 0];
					this.currImageScale = [1, 1];
					this.currImageRotation = 0;

				}
			}
		},
		components: {
			InputRange,
			InputCoordsDrag,
			InputAngle
		},
		data() {

			this.creative = null;
			this.asset = null;
			this.variation = null;
			this.image = null;

			this.assetDimension = null;

			this.currImageWidth = 0;
			this.currImageHeight = 0;
			this.currImageObj = new Image();
			this.currImageObj.onload = () => {
				this.recalculate();
			};

			this.origImageWidth = 0;
			this.origImageHeight = 0;
			this.origImageObj = new Image();
			this.origImageObj.onload = () => {
				this.recalculate();
			};

			this.dragProcess = null;

			return {
				editMode: false,
				canvasWidth: 750,
				canvasHeight: 750,
				globalScale: 1,
				currImageOffset: [0, 0],
				currImageScale: [1, 1],
				currImageMinScale: 0.01,
				currImageMaxScale: 3,
				currImageScaleStep: 0.01,
				currImageRotation: 0
			}

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.showed && this.dragProcess) this.stopDrag();

			});

			window.addEventListener("mousemove", e => {

				if (this.showed && this.dragProcess) this.processDrag(e);

			});

			window.addEventListener("resize", e => {

				if (this.showed) this.recalculate();

			});

		},
		methods: {
			collectData() {

				if (this.variation) this.updateAssetDimension();

			},
			updateAssetDimension() {

				this.assetDimension = Asset.getDimension(this.creative.id, this.asset.codename, this.variation.type, this.variation.generation?.id || this.variation.upload?.id || 0, this.variation.generation ? this.image.fileName : '');

				if (this.assetDimension) {

					if (!this.currImageOffsetChanged) this.currImageOffset = [...this.assetDimension.offset];
					if (!this.currImageScaleChanged) this.currImageScale = [...this.assetDimension.scale];
					if (!this.currImageRotationChanged) this.currImageRotation = this.assetDimension.rotation;

				}

			},
			recalculate() {

				this.canvasWidth = this.canvasHeight = Math.min(750, window.innerHeight - 300);

				if (this.currImageScale[0] < this.currImageMinScale) this.currImageScale[0] = this.currImageMinScale;
				if (this.currImageScale[0] > this.currImageMaxScale) this.currImageScale[0] = this.currImageMaxScale;
				if (this.currImageScale[1] < this.currImageMinScale) this.currImageScale[1] = this.currImageMinScale;
				if (this.currImageScale[1] > this.currImageMaxScale) this.currImageScale[1] = this.currImageMaxScale;

				this.currImageScale[0] = Math.round(this.currImageScale[0] * 100) / 100;
				this.currImageScale[1] = Math.round(this.currImageScale[1] * 100) / 100;

				let currImageWidth = this.currImageWidth = this.currImageObj.width * this.currImageScale[0];
				let currImageHeight = this.currImageHeight = this.currImageObj.height * this.currImageScale[1];

				// Вывсчитываем размеры с учетом поворота
				if (this.$refs["currEl"]) {

					const angleRadians = this.currImageRotation * (Math.PI / 180);

					const cos = Math.abs(Math.cos(angleRadians));
					const sin = Math.abs(Math.sin(angleRadians));

					currImageWidth = this.currImageWidth * cos + this.currImageHeight * sin;
					currImageHeight = this.currImageWidth * sin + this.currImageHeight * cos;

				}

				let currImageWidthScale = (this.canvasWidth / 2) / ((currImageWidth / 2) + Math.abs(this.currImageOffset[0]));
				let currImageHeightScale = (this.canvasHeight / 2) / ((currImageHeight / 2) + Math.abs(this.currImageOffset[1]));

				this.origImageWidth = this.origImageObj.width;
				this.origImageHeight = this.origImageObj.height;

				let origImageWidthScale = this.canvasWidth / this.origImageWidth;
				let origImageHeightScale = this.canvasHeight / this.origImageHeight;

				//let minScale = _.min([currImageWidthScale, currImageHeightScale, origImageWidthScale, origImageHeightScale]),
				//	maxScale = 1;

				// Если все картинки более чем в 5 раз меньше канваса - сделаем максимальный скейл не 1, а 2
				//if (minScale > 5) maxScale = 2;

				//this.globalScale = _.min([maxScale, currImageWidthScale, currImageHeightScale, origImageWidthScale, origImageHeightScale]);

				this.globalScale = _.min([1, currImageWidthScale, currImageHeightScale, origImageWidthScale, origImageHeightScale]);

				console.log('globalScale', this.globalScale, 'currImageScale', this.currImageScale);

				this.update();

			},
			setCurrImageScale(scale) {

				this.currImageScale = scale;
				this.currImageScaleChanged = true;

				this.recalculate();

			},
			setCurrImageScaleByWheel(e) {

				if (!this.editMode) return;

				if (e.deltaY !== 0) {

					e.preventDefault();

					this.setCurrImageScale([this.currImageScale[0] + e.deltaY * 0.0003, this.currImageScale[1] + e.deltaY * 0.0003]);

				}

			},
			setCurrImageOffset(offset) {

				this.currImageOffset = offset;
				this.currImageOffsetChanged = true;

				this.recalculate();

			},
			setCurrImageRotation(rotation) {

				this.currImageRotation = rotation;
				this.currImageRotationChanged = true;

				this.recalculate();

			},
			startDrag(e) {

				if (!this.editMode) return;

				this.dragProcess = {
					active: false,
					downValue: [...this.currImageOffset],
					downPointerPosition: {
						x: e.clientX,
						y: e.clientY
					}
				};

			},
			processDrag(e) {

				if (this.dragProcess.active) {

					let offsetX = (e.clientX - this.dragProcess.downPointerPosition.x) / this.globalScale,
						offsetY = (e.clientY - this.dragProcess.downPointerPosition.y) / this.globalScale;

					//if (this.options.controlOptions["revertY"]) offsetY *= -1;

					// Делаем так чтобы смещение на 10 пикселей смещало значение на один шаг
					/*if (this.options.changes?.step) {

						let pixelWeight = this.options.changes?.step / 10;

						offsetX = offsetX * pixelWeight;
						offsetY = offsetY * pixelWeight;

					}*/

					this.currImageOffset = [this.dragProcess.downValue[0] + offsetX, this.dragProcess.downValue[1] + offsetY];
					this.currImageOffsetChanged = true;

				} else {

					let dx = e.clientX - this.dragProcess.downPointerPosition.x,
						dy = e.clientY - this.dragProcess.downPointerPosition.y;

					this.dragProcess.active = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2)) > 3;

				}

			},
			stopDrag() {

				this.dragProcess = null;

				this.recalculate();

			},
			save() {

				// Размеры итогового изображения
				let width = this.canvasWidth / this.globalScale,
					height = this.canvasHeight / this.globalScale;

				// Координаты начала отрисовки изображения (левый верхний угол)
				let imgX = Math.round(width / 2 - this.currImageWidth / 2 + this.currImageOffset[0]),
					imgY = Math.round(height / 2 - this.currImageHeight / 2 + this.currImageOffset[1]);

				let canvas = document.createElement('canvas');

				/*canvas.style.position = 'fixed';
				canvas.style.left = '0px';
				canvas.style.top = '0px';
				canvas.style.zIndex = '999999';

				document.body.appendChild(canvas);*/

				canvas.width = width;
				canvas.height = height;

				const ctx = canvas.getContext('2d');

				ctx.drawImage(this.currImageObj, imgX, imgY, this.currImageWidth, this.currImageHeight);

				console.log('getImageContent', width, height, Math.abs(imgX), Math.abs(imgY), this.currImageWidth, this.currImageHeight);

				canvas.toBlob(async (blob) => {

					const formData = new FormData();

					let clientData = {},
						endPoint = '';

					if (this.variation.type === "generation") {

						clientData.assetGenerationId = this.variation.generation?.id;
						clientData.fileName = this.image.fileName; // это нужно для привязки конкретного изображения из генерации (их может быть несколько) к создаваемому dimension картинки

						endPoint = `/asset/setGenerationDimension`;

					} else if (this.variation.type === "upload") {

						clientData.assetUploadId = this.variation.upload?.id;

						endPoint = `/asset/setUploadDimension`;

					} else if (this.variation.type === "original") {

						clientData.versionId = this.asset["version_id"];
						clientData.assetCodename = this.asset["codename"];

						endPoint = `/asset/setOriginalDimension`;

					}

					clientData.offset = this.currImageOffset;
					clientData.scale = this.currImageScale;
					clientData.rotation = this.currImageRotation;

					clientData.format = 'png';

					formData.append('clientData', JSON.stringify(clientData));
					formData.append('file', blob, 'asset.png');

					await fetch(`${location.protocol}//${SetupSettings["domain"]}${endPoint}`, {
						method: 'POST',
						headers: Auth.getAuthHeaders(),
						body: formData
					});

				}, 'image/png');

			},
			reset() {

				this.editMode = false;

				Server.sendToSocket({
					ResetAssetDimension: {
						assetDimensionId: this.assetDimension.id
					}
				});

			},
			deleteUpload(e) {

				Broadcast.call('Show Confirm', [{
					caption: 'Delete image',
					message: `Are you sure you want to delete this image?`,
					confirmButtonText: '&nbsp;&nbsp;Delete image',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteImage: {
								imageId: 0
							}
						});
						this.closeWindow();
					}
				}]);

			},
			async downloadImage(variation, image) {

				// 1. Fetch the image
				const response = await fetch(image.path);
				const blob = await response.blob();

				// 2. Create a temporary object URL from the blob
				const blobURL = URL.createObjectURL(blob);

				// 3. Create a hidden <a> tag and click it programmatically
				const link = document.createElement('a');
				link.href = blobURL;
				link.download = image.fileName; // The name the user will see
				document.body.appendChild(link);
				link.click();

				// 4. Cleanup
				document.body.removeChild(link);
				URL.revokeObjectURL(blobURL);

			}
		}
	}
</script>


<style lang="sass">

	.asset-image-info
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 940px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			button
				white-space: nowrap
				margin-right: 20px

				i
					margin-right: 10px

			.download-button

				i
					margin-right: 0

			.btn-ghost-dark, .btn-dark
				color: #fff

			.btn-link
				color: #fff

			.btn-link:hover
				color: #fff

			.card-header
				display: flex
				flex-direction: row

				.date
					color: rgba(255,255,255,0.1)
					margin-left: auto

		.form-group
			display: flex
			flex-direction: column
			margin: 0

			&:first-child
				margin-left: 0

		.form-line
			display: flex
			flex-direction: row
			justify-content: center
			align-items: center

		.field-title
			margin-bottom: 5px
			cursor: default
			color: var(--gray)

		.canvas
			position: relative
			width: 750px
			height: 750px
			overflow: hidden

			.image
				position: absolute
				background-position: center
				background-size: 100% 100%
				background-repeat: no-repeat
				border: 2px solid var(--gray-dark)
				pointer-events: none

			.original-image-rect
				position: absolute
				background-position: center
				background-size: contain
				background-repeat: no-repeat
				background-color: rgba(0,0,0,0.5)
				border: 2px dashed rgba(255,255,255,0.5)
				opacity: 0.5
				pointer-events: none

		.controls
			display: flex
			flex-direction: row
			justify-content: left
			padding-top: 5px
			padding-bottom: 15px

			.control
				display: flex
				flex-direction: row
				align-items: center
				margin-left: 20px

				> span
					margin-right: 10px

			.control:first-child
				margin-left: 0

			.range-input
				width: 150px

		.form-actions
			display: flex
			flex-direction: row
			align-items: center
			margin-top: 20px

			.right-button
				margin-left: auto

</style>

